
import {createSelector} from 'reselect';
export const selectedShopRoot = state => state.SelectedShop;
